module.exports = __webpack_public_path__ + "img/1KG.deb24f8b.jpg";